<template>
	<el-upload
		:multiple="multiple"
		:key="name"
		action="#"
		ref="upload"
		:on-remove="handleRemove"
		:on-preview="handlePreview"
		:on-change="handleChange"
		:file-list="fileList"
		:http-request="uploadFile"
		:before-upload="beforeAvatarUpload"
	>
		<el-button type="primary">点击上传（可多选）</el-button>
		<div slot="tip" class="el-upload__tip">文件要求jpg、jpeg、png格式，大小不超过1M</div>
	</el-upload>
</template>

<script>
import { reqUploadFile } from '@/api';
export default {
	props: {
		name: {
			type: String,
			required: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
		path: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			fileList: []
		};
	},
	mounted() {
		console.log(this.multiple);
	},
	methods: {
		uploadFile(options) {
			let query = {
				file: options.file
			};
			this.path ? (query.path = sessionStorage.getItem('path') ? sessionStorage.getItem('path') : sessionStorage.getItem('name')) : '';
			reqUploadFile(query, options.onProgress)
				.then(res => {
					options.onSuccess(res.data);
					this.$emit('add:files', {
						url: res.data,
						name: options.file.name
					});
				})
				.catch(() => {
					options.onError();
				});
		},
		// 点击删除
		handleRemove(file, fileList) {
			this.fileList = fileList;
			this.$emit('del:files', fileList);
		},
		beforeAvatarUpload(file) {
			const isLtSize = file.size / 1024 / 1024 <= 2;

			if (!isLtSize) {
				this.$message.error('上传文件大小不能超过 2M!');
				return false;
			}
			return isLtSize;
		},
		handleChange(file, fileList) {
			this.fileList = fileList.map(v => {
				if (v.response) {
					return {
						name: v.name,
						url: v.response
					};
				} else {
					return v;
				}
			});
		},
		handlePreview(file) {
			window.open(file.url);
		}
	}
};
</script>

<style></style>
